export default "__VITE_ASSET__BqztdXDC__"